<template>
  <b-card body-class="p-0 my-2" :style="`height:${isMobile ? 256 : 225}px; overflow-y:scroll;`">
    <category-list-item
      v-for="(category, i) in categories"
      :key="category.id"
      :category="category"
      :selected="selectedIndex == i"
      :isMobile="isMobile"
      :viewer="me"
      :owner="findUser(category.owner)"
      v-on:clickCategory="selectedCategory"
    />
  </b-card>
</template>

<script lang="ts">
import { defineComponent, ref, watch, type PropType } from "vue";
import { useUserStore } from "@/store";
import { Category, User } from "../model";
import CategoryListItem from "./CategoryListItem.vue";

export default defineComponent({
  name: "category-list",
  components: {
    CategoryListItem,
  },
  props: {
    domainId: { type: String, default: () => "" },
    isMobile: { type: Boolean, default: () => false, required: true },
    categories: { type: Array as PropType<Category[]>, default: () => [], required: true },
    // ログインユーザー情報
    me: { type: Object as PropType<User>, default: () => User.createNotFoundUser() },
    attachedCategories: { type: Array as PropType<Category[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const selectedIndex = ref<number>(0);
    const users = ref<User[]>([]); // 組織内ユーザー情報

    watch(
      () => props.categories,
      (): void => {
        if (!props.attachedCategories.length) {
          selectedIndex.value = -1;
          return;
        }
        // 現在はカテゴリー1つの選択
        const selected = props.attachedCategories[0];
        const index = props.categories.findIndex((c) => c.id == selected.id);
        selectedIndex.value = index;
      },
      // CategoryEdit は同一参照のまま splice で categories を変更するため、
      // 参照変更なしでも発火するよう deep 指定（旧 @Watch は in-place 変更でも発火していた）
      { immediate: true, deep: true }
    );

    watch(
      () => props.attachedCategories,
      (): void => {
        if (!props.attachedCategories.length) {
          selectedIndex.value = -1;
          return;
        }
        // 現在はカテゴリー1つの選択
        const selected = props.attachedCategories[0];
        const index = props.categories.findIndex((c) => c.id == selected.id);
        selectedIndex.value = index;
      },
      { immediate: true }
    );

    const selectedCategory = (id: string): void => {
      const index = props.categories.findIndex((c) => c.id == id);
      selectedIndex.value = index;
      const category = props.categories[selectedIndex.value];
      if (category) {
        emit("selected", { id: category.id });
      }
    };

    const findUser = (ownerId: string): User => {
      const user = users.value.find((user) => user.id == ownerId);
      return user ? user : User.createNotFoundUser(ownerId);
    };

    // created 相当
    const getByDomainId = useUserStore().getByDomainId;
    if (getByDomainId) {
      users.value = getByDomainId(props.domainId) as User[];
    }

    return {
      selectedIndex,
      users,
      selectedCategory,
      findUser,
    };
  },
});
</script>
